import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";

export interface CurrenciesList {
    subsidiary: number;
    accepted_coins: number[];
    accepted_bills: number[];
}

export function currenciesList(
    state: CurrenciesList = {
        subsidiary: 0,
        accepted_coins: [],
        accepted_bills: []
    },
    action: Action
) {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_CURRENCIES:
            return Object.assign({}, state, {
                subsidiary: action.payload.subsidiaryId
            });
        case ConfigurationsActionTypes.GET_CURRENCIES_SUCCESS:
            let response = action.payload.results
            if(response.length>0){
                response = response[0];
                action.payload.results.forEach(item => {
                    if (item.subsidiary === state.subsidiary) response = item;
                });
                return Object.assign({}, state, {
                    accepted_coins: response.coins,
                    accepted_bills: response.bills
                });
            }else{
                return Object.assign({}, state, {
                    accepted_coins: [],
                    accepted_bills: []
                });
            }

        default:
            return state;
    }
}
